export enum MercerDialogType {
  Manager = 'Manager',
  Support = 'Support',
  Headcount = 'Headcount',
  StandingSupport = 'StandingSupport',
  StandingEmployeeProfile = 'StandingEmployeeProfile',
  StandingMerit = 'StandingMerit' // promotion process, may not persist/change CPE data
}
